<template>
  <v-container style="max-width:1000px" class="mt-8">
  <h1>View Public Data</h1>

    <v-card
     class="my-8"
     flat
     v-for="d of data.results"
     v-bind:key="d.id"
    >
     <v-card-title>
      {{d.name}}
     </v-card-title>

     <v-card-subtitle>
      {{d.creation_date | dateParse('YYYY-MM-DD HH:mm:ss') | dateFormat('DD MMM. YYYY // HH:mm')}}
     </v-card-subtitle>

     <v-card-text>
      {{d.description}}
     </v-card-text>

     <v-card-actions>
       <v-btn class="ma-2" tile outlined color="success" :to="{ name: 'dataDetail', params: { dataId: d.id }}">
         <v-icon left>mdi-map</v-icon> Create Map
       </v-btn>
     </v-card-actions>
   </v-card>

   <v-pagination
    :value="curPage"
    :length="count"
    :total-visible="7"
    @input="click"
    color="secondary"
  ></v-pagination>
 </v-container>
</template>

<script>

export default {
  data () {
    return {
      data: [],
      count: 0,
      curPage: 1
    }
  },
  created () {
    this.all()
  },
  methods: {
    all: function () {
      this.axios.get('data/')
        .then(response => {
          this.data = response.data
          this.count = Math.ceil(this.data.count / process.env.VUE_APP_PAGE_SIZE)
        })
    },
    click (page) {
      var offset = process.env.VUE_APP_PAGE_SIZE * (page - 1)
      this.axios.get('data/', { params: { limit: process.env.VUE_APP_PAGE_SIZE, offset: offset } })
        .then(response => {
          this.data = response.data
          this.curPage = page
        })
    }
  }
}
</script>
